import { InMemoryCache, TypePolicies } from '@apollo/client/core';

export const apolloTypePolicies: TypePolicies = {
  OrderFinance: {
    merge: false,
  },
  FlightItineraryGroupNode: {
    merge: false,
  },
  WholeCalls: {
    // twilio_calls and ringcentral_calls are independent id sequences, so one lead can
    // return the same numeric id once per provider; identity must carry the provider or
    // the two calls collapse into a single entity and overwrite each other's fields.
    // Same bug class as SecureCreditCard below. GetInteractions is the only operation
    // selecting WholeCalls and it always selects callProvider.
    keyFields: ['id', 'callProvider'],
  },
  SecureCreditCard: {
    keyFields: ['id', 'number'], // for disable deep merge similar cards with identical id and different numbers (for another role etc)
  },
};

export const createApolloCache = () => new InMemoryCache({ typePolicies: apolloTypePolicies });
